import { render, staticRenderFns } from "./ConstructionPeriodTypesSelect.vue?vue&type=template&id=0dea10e3&scoped=true&lang=pug"
import script from "./ConstructionPeriodTypesSelect.vue?vue&type=script&lang=js"
export * from "./ConstructionPeriodTypesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dea10e3",
  null
  
)

export default component.exports